import React from 'react';
import styled from '@emotion/styled';

import { Container, Col, Row } from '@/components/grid';
import Error from '@/pages/_error';
import { SPACE, CACHE } from '@/constants';
import { H1 } from '@/components/type';
import Layout from '@/components/layout';
import TextLinksList from '@/components/text-links-list';
import { fetch } from '@/utils/api';
import LinkList from '@/components/link-list';
import generateSitemap from '@/utils/generate-sitemap';
import { withAppProps, withAppProviders } from '@/utils/withAppProps';

const StyledH1 = styled(H1)`
  margin-bottom: ${
    /* @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'hasExtraSpacing' does not exist on type '{ theme?: Theme | undefined; as?: ElementType<any, keyof IntrinsicElements> | undefined; } & ClassAttributes<HTMLHeadingElement> & HTMLAttributes<...> & { ...; } & { ...; }'. */
    (props) => (props.hasExtraSpacing ? SPACE.X3 : `calc(${SPACE.X1} + ${SPACE.X0})`)
  };
  margin-top: ${SPACE.X3};
`;

type SitemapProps = {
  sitemap: {
    safetyFeaturesEntries?: {
      title?: string;
      url?: string;
    }[];
    vehicleMakesEntries?: {
      title?: string;
      uri?: string;
    }[];
    didYouKnowTipsEntries?: {
      title?: string;
      url?: string;
    }[];
  };
  statusCode?: number;
};

const Sitemap = ({ sitemap, statusCode = 200 }: SitemapProps) => {
  const titleRef = React.useRef();

  React.useEffect(() => {
    if (titleRef.current) {
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'focus' does not exist on type 'never'.
      titleRef.current.focus();
    }
  }, [titleRef]);

  if (statusCode !== 200) {
    return <Error {...{ statusCode }} />;
  }

  const title = 'Site Map';

  const sitemapItems = generateSitemap(sitemap);

  return (
    <Layout>
      <Container maxWidth="xl">
        {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'string' is not assignable to type 'number'. */}
        <StyledH1 tabIndex={-1} ref={titleRef}>
          {title}
        </StyledH1>

        <Row>
          <Col width={{ xs: 12, lg: 6 }}>
            <h2>Pages</h2>
            <TextLinksList>
              <LinkList items={sitemapItems.primary} />
            </TextLinksList>
          </Col>

          <Col width={{ xs: 12, lg: 6 }}>
            <h2>Vehicle Makes</h2>
            <TextLinksList>
              <LinkList items={sitemapItems.vehicleMakesEntries} />
            </TextLinksList>
          </Col>
        </Row>
      </Container>
    </Layout>
  );
};

const getStaticProps = withAppProps(async () => {
  const contentQuery = `{
    safetyFeaturesEntries: entries(section: "tacSafetyFeatures") {
      id
      title
      url
    }
    vehicleMakesEntries: entries(section: "vehicles", level: 1) {
      id
      title
      uri
    }
  }`;

  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Expected 2 arguments, but got 1.
  const contentQueryResponse = await fetch({ query: contentQuery });

  return {
    props: {
      sitemap: contentQueryResponse.data.data,
    },
    revalidate: CACHE.REVALIDATE,
  };
});

export default withAppProviders(Sitemap);
export { getStaticProps };
